export type ImageAssetType = 'orgLogos'|'menuSections'|'menuItems'|'menuItemThumbnails'|'menuSlides'|'menuOrgAttrsBackgrounds'|'menuOrgAttrsLogos';

interface ImageProps {
    type?: ImageAssetType;
    className: string;
    style?: React.CSSProperties;
    alt: string;
    src: string;
}
const URL = (process.env.REACT_APP_IMAGE_URL||"").replace("http://", "https://");

function getImageUrl(type: string, src: string) {
    return URL + type + '/' + src;
}

export function Image(props: ImageProps) {
    return (
        <img alt={props.alt||""} src={props.src?props.type?getImageUrl(props.type, props.src):props.src:""}
            className={props.className} style={props.style}/>
    )
}

const ANIMATED_EXT = /\.(mp4|gif)$/i;

/**
 * The still-image file name for any item main image, mirroring the menus
 * resolver. Animated media resolves to its generated JPEG poster.
 *
 * The poster lives in a different bucket folder than the original, so this
 * must always be paired with itemPosterType — passing type="menuItems"
 * alongside a poster name points at a folder that has no such object.
 */
export function itemPosterSrc(src: string): string {
    if (!ANIMATED_EXT.test(src)) return src;
    return src.replace(/\.[^.]+$/, "_thumb.jpg");
}

/** The asset folder the result of itemPosterSrc lives in. */
export function itemPosterType(src: string): ImageAssetType {
    return ANIMATED_EXT.test(src) ? "menuItemThumbnails" : "menuItems";
}

/**
 * Renders <video> for .mp4 and <img> otherwise. Use ONLY on single-item
 * surfaces - in a list this would autoplay every original.
 *
 * Takes ImageProps directly rather than an empty extending interface, which
 * would trip @typescript-eslint/no-empty-interface.
 */
export function Media(props: ImageProps) {
    const src = props.src ? (props.type ? getImageUrl(props.type, props.src) : props.src) : "";

    if (props.src?.toLowerCase().endsWith(".mp4")) {
        return (
            <video src={src} className={props.className} style={props.style}
                   muted loop playsInline autoPlay/>
        );
    }
    return <Image {...props}/>;
}
